<template>
  <div>
    <el-form
      :model="form"
      ref="form"
      :inline="true"
      size="normal"
      label-suffix="："
      class="base-form"
      :rules="rules"
      :size="size"
    >
      <el-form-item
        v-for="(item, index) in $attrs.tableSearch"
        :label="item.label"
        :key="index"
        :prop="item.fieldKey + ''"
      >
        <el-input
          style="width:180px"
          v-if="item.type === 'input'"
          v-model="form[item.fieldKey]"
          v-bind="item"
          :placeholder="item.placeholder || item.label"
          @keydown.native.enter="searchHandler"
          clearable
        ></el-input>
        <el-autocomplete
          clearable
          resize="both"
          popper-class="autocomplete"
          v-if="item.type === 'autocomplete'"
          v-model="form['__' + item.fieldKey]"
          @input="e => (form[item.fieldKey] = '')"
          @blur="
            e =>
              temporaryTimeout(() => {
                !form[item.fieldKey] &&
                  ((form['__' + item.fieldKey] = ''),
                  (form[item.fieldKey] = ''));
              })
          "
          @select="e => (form[item.fieldKey] = e.id)"
          :fetch-suggestions="item.querySearchAsync"
          v-bind="item"
        ></el-autocomplete>
        <el-select
          style="width:120px"
          v-if="item.type === 'select'"
          v-model="form[item.fieldKey]"
          :placeholder="item.placeholder || '请选择'"
          clearable
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
        <el-date-picker
          v-if="item.type === 'month'"
          v-model="form[item.fieldKey]"
          :placeholder="item.placeholder || '请选择月份'"
          v-bind="item"
          width="80px"
          clearable
          type="month"
        ></el-date-picker>
        <el-date-picker
          v-if="item.type === 'daterange'"
          v-model="form['__daterange' + index]"
          @input="v => daterangeHandler(v, item)"
          type="daterange"
          range-separator="至"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :clearable="!item.noclearable"
          :start-placeholder="item.startPlaceholder || '开始日期'"
          :end-placeholder="item.endPlaceholder || '结束日期'"
          :pickerOptions="item.pickerOptions || {}"
        ></el-date-picker>
        <el-cascader
          v-if="item.type === 'cascader'"
          v-model="form[item.fieldKey]"
          :options="item.options"
          :props="{ checkStrictly: true }"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          style="margin-right: 8px"
          @click="searchHandler"
        >
          搜索
        </el-button>
        <slot name="tableActions"></slot>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'base-form',
  props: {
    size: {
      type: [String],
      // validator: function(value) {
      //   // 这个值必须匹配下列字符串中的一个
      //   return !!~['medium', 'small', 'mini'].indexOf(value);
      // },
      // required: false,
      default: 'small'
    }
  },
  data() {
    return {
      form: {},
      rules: {},
      formatters: {}
    };
  },
  beforeDestroy() {},
  watch: {
    realForm: {
      handler: function(realForm) {
        if (!realForm) return {};
        Object.keys(realForm).forEach(key => {
          if (this.formatters[key]) {
            this.form[key] =
              this.formatters[key] && this.formatters[key](realForm[key]);
          }
        });
        this.$emit('change', realForm);
      },
      deep: true
    }
  },
  computed: {
    // 没有空字段的表单
    realForm: {
      get: function() {
        let rep = {};
        Object.keys(this.form).forEach(key => {
          let val = this.form[key];
          if (!/^__/.test(key) && val !== '') {
            rep[key] = val;
          }
        });
        return rep;
      },
      set: function(v) {
        return v;
      }
    }
  },
  methods: {
    // 临时解决办法
    temporaryTimeout(fn) {
      setTimeout(fn, 400);
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    searchHandler() {
      // this.$nextTick(() => {
      this.$emit('search', this.realForm);
      // });
    },
    daterangeHandler(value, item) {
      const [sfield, efield] = item.fieldKeys;
      if (value == null) {
        this.form[sfield] = '';
        this.form[efield] = '';
        return;
      }
      const [f, e] = value;
      if (!sfield || !efield) return;
      this.form[sfield] = f;
      this.form[efield] = e;
    }
  },
  created() {
    const { tableSearch } = this.$attrs;
    if (!tableSearch) return;
    // const daterangeList = []
    try {
      tableSearch.forEach((i, index) => {
        i.formatter && (this.formatters[i.fieldKey] = i.formatter);
        //   i.rule && (this.rules[i.fieldKey] = i.rule);
        // this.$set(this.form,'')
        if (i.type === 'daterange') {
          // 处理日期组件
          this.$set(this.form, [`__daterange${index}`], i.defaultValue || []);
        } else {
          this.$set(this.form, [i.fieldKey], i.defaultValue || '');
        }
      });
    } catch (err) {
      console.error(err);
    }
  }
};
</script>
<style lang="scss">
.base-form {
  /*text-align: left;*/
  overflow: hidden;
  background: #fff;
  padding: 20px 10px 0 10px;
  /*border-radius: 4px;*/
  /*box-shadow: 0 1px 3px rgba(0, 0, 0, .3)*/
  .el-cascader__dropdown .el-scrollbar__wrap {
    overflow: hidden !important;
    margin-bottom: 0px !important;
    margin-right: 0px !important;
  }
  .autocomplete {
    width: auto !important;
    /*background: #46a6ff;*/
  }
}
</style>
